/* eslint-disable import/prefer-default-export */

'use server';

import { cookies } from 'next/headers';

import API from '~/config/api';
import fetchJson from '~/utils/Fetch/json';

export async function createContact(prevState, formData) {
  const cookieStore = await cookies();
  const sessionUuid = cookieStore.get('rea_session_uuid')?.value;

  if (!sessionUuid) {
    return {
      alert: 'error',
      errors: {},
      formData,
    };
  }

  const payload = {
    full_name: formData.get('full_name'),
    first_name: formData.get('full_name').split(' ')[0],
    last_name: formData.get('full_name').split(' ').pop(),
    email: formData.get('email'),
    message: formData.get('message'),
    session_uuid: sessionUuid,
  };

  let responseObject = {
    alert: 'error',
    errors: {},
    formData,
  };

  await fetchJson(
    API.contactUs({}),
    API.POST_CONFIG({
      data: payload,
    }),
  )
    .then(() => {
      responseObject = {
        alert: 'success',
        errors: {},
        formData: {},
      };
    })
    .catch((error) => {
      responseObject = {
        alert: 'error',
        rateLimited: error?.response?.status === 429,
        errors: {},
        formData: payload,
      };
    });

  return responseObject;
}
